import styled from 'styled-components';
import { colors, fontWeights, heading4, spacing } from 'ui/theme';
import { Takeover } from 'ui/workflows/takeover';
import { TakeoverDrawer } from 'ui/workflows/takeover/Takeover.styles';

export const StyledTakeoverHeader = styled.div`
  ${heading4}
  font-weight: ${fontWeights.bold};
  color: ${colors.white};
`;

export const StyledTakeoverFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.base};
`;

export const StyledTakeover = styled(Takeover)`
  ${TakeoverDrawer} {
    width: ${spacing.x40};
  }
`;

export const TakeoverContainerWrapper = styled.div`
  padding: ${spacing.plusHalf};
`;
